// config/supabaseClient.js
import { createClient } from '@supabase/supabase-js'

// These MUST match your .env file exactly
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Debug: Check if variables are loaded (remove in production)
console.log('Supabase URL:', supabaseUrl)
console.log('Supabase ANON Key exists:', !!supabaseAnonKey)

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase credentials! Check your .env file')
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)